import { isArray } from 'util';
import { Operator } from '../operator';
import { OperatorCapability } from '../operator-capability';

export class OperatorCapabilityBuilder {
  static fromJson(json) {
    return (json)
      ? new OperatorCapability(
        json.hash,
        json.modelHash,
        json.modelName,
        json.modelReference,
        json.level,
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(OperatorCapabilityBuilder.fromJson) : [];
  }
}

export class OperatorBuilder {
  static fromJson(json) {
    return (json)
      ? new Operator(
        json.hash,
        json.code,
        json.name,
        json.active,
        json.workingModelGroupHash,
        json.workingModelGroupName,
        json.operatorGroupHash,
        json.operatorGroupName,
        OperatorCapabilityBuilder.fromList(json.capabilities),
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(OperatorBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/operator.builder.ts